module.exports = __webpack_public_path__ + "img/petit.fe83bf92.jpg";